import Scheduling from "../../../api/scheduling";
import Quotas from "../../../api/quotas";
import moment from "moment";

const QuotasServices = {
    //Retrieve this client schedules if exists
    getQuotaSchedulings: async(payload) => {
        const { dates } = payload;
        const schedulingsData = {
            client_document: payload.client_document,
            startDate: dates[0].date,
            endDate: dates[6].date
        }
        return await Scheduling.getClientQuantitySchedulingByPeriod(schedulingsData);
    },
    //Validates if this client is not already in the state, if so, returns the client
    checkIfClientIsAlreadyInState: (quotas, payload) => {
       return quotas.filter(quota => {
            return quota.client_document === payload.client_document
        });
    },
    //Filters if there are schedules by data inside the loop
    filterSchedulingsByDate: (schedulings, payload, weekDay) => {
        return schedulings.data.filter( schedule => {
            if( !payload.transporter_document ) {
                return schedule.date === weekDay;
            }
            return schedule.date === weekDay && schedule.transporter_document === payload.transporter_document;
        })
    },
    //Decreases the number of appointments that will be compensated in the new client
    handleIfQuotaAlreadyExists: (quotasInState, weekDay, schedules, clientDocument) => {
        if(quotasInState.length > 0) {
            const principalQuota = QuotasServices.getPrincipalQuotaDataFromState(quotasInState, clientDocument)
 
            if(!principalQuota) {
                return;
            }

            const { dates } = principalQuota;
            QuotasServices.decreasePrincipalQuotaQtyByDate(dates, weekDay, schedules);

            //Prepare item object to send to substractQuantity function
            let item =  { 
              row: principalQuota,
              weekDay: weekDay.date,
              alreadyScheduled: schedules[0].qty,
            };

            //Get actual date on dates of object
            const date = dates.find( field => {
                return field.date === weekDay.date;
            })

            return { date, item };
        }

        return false;
    },
    //Get the unique quota without transporter documment from this client ( definied as Principal Quota )
    getPrincipalQuotaDataFromState: (quotasInState, client_document) => {
        const principalQuota = quotasInState.find( clientData => {
            if(clientData.client_document === client_document && clientData.transporter_document === "") {
                return true;
            }
            return false;
        });

        return principalQuota ?? false;
    },
    //Decrease a qtd from principal quota on specific date    
    decreasePrincipalQuotaQtyByDate: (QuotaDates, weekDay, schedules) => {
        QuotaDates.map( date => {
            if( date.date === weekDay.date ) {
              return date.alreadyScheduled = date.alreadyScheduled - schedules[0].qty;
            }
            return true;
        })
    },
    //Handle and prepare quotas to clone
    getLastAndThisWeekQuotas: async (payload) => {
        let structuredClonedQuotas = [];
        let lastWeekQuotasData     = [];
        let thisWeekQuotasData     = [];

        if (payload) {
          const { idPlant, startDate, endDate, plantStartDateLastWeek, plantEndDateLastWeek, idTimeBlock } = payload;
          const lastWeekQuotas = await Quotas.listByClient(idPlant, plantStartDateLastWeek, plantEndDateLastWeek, idTimeBlock);
          const thisWeekQuotas = await Quotas.listByClient(idPlant, startDate, endDate, idTimeBlock);
          lastWeekQuotasData = lastWeekQuotas.data;
          thisWeekQuotasData = thisWeekQuotas.data;

          lastWeekQuotasData.availableDays = thisWeekQuotasData.availableDays;
          structuredClonedQuotas = lastWeekQuotasData;
        }
        
        return { structuredClonedQuotas, thisWeekQuotasData };
    },
    //Clone quotas from last week and update dates of quotas to this week.
    handleThisWeekQuotas: async (structuredClonedQuotas, thisWeekQuotasData) => {
        const todayDate = new Date().toLocaleDateString('en-CA');

        structuredClonedQuotas.quotas.map( function(quota, index) {
            Object.keys(quota.dates).forEach( dateIndex => {
              let dateDay = quota.dates[dateIndex].date;
              quota.dates[dateIndex].date = moment(dateDay).add(7,'d').format('YYYY-MM-DD')

              if(quota.dates[dateIndex].date < todayDate) {
                quota.dates[dateIndex].allocated = thisWeekQuotasData.quotas[index]?.dates[dateIndex].allocated ?? 0;
              }
            })
            return true;
        });
    },
    //Check if has schedulings from this client and apply to alreadyScheduled key.
    handleSchedulingsFromThisWeek: async (structuredClonedQuotas) => {
        for ( const quota of structuredClonedQuotas.quotas ) {
            const { data } = await QuotasServices.getQuotaSchedulings(quota)
            let { dates }  = quota;

            dates.map( async date => {
                const scheduling = data.find( schedule => {
                    return schedule.date === date.date && quota.transporter_document === schedule.transporter_document;
                });

                if(scheduling) {
                    date.allocated = scheduling.qty;
                    date.alreadyScheduled = scheduling.qty;
                    return true;
                }

                date.alreadyScheduled = 0;
                return true;
            });
        }
    }

  };

export default QuotasServices;